import * as React from 'react';
import Svg, {Path, Circle} from 'react-native-svg';

interface IProps {
  size?: number;
}

function LocationPermissionErrorIconAramark({size = 74}: IProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 74 74" fill="none">
      <Path
        d="M60.125 31.862C60.125 49.848 37 65.265 37 65.265S13.875 49.848 13.875 31.862a23.125 23.125 0 1146.25 0z"
        fill="#D23580"
      />
      <Path
        d="M37 39.57a7.708 7.708 0 100-15.416 7.708 7.708 0 000 15.416z"
        fill="#D23580"
      />
      <Path
        d="M60.125 31.862C60.125 49.848 37 65.265 37 65.265S13.875 49.848 13.875 31.862a23.125 23.125 0 1146.25 0z"
        stroke="#D23580"
        strokeWidth={2.08333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M37 39.57a7.708 7.708 0 100-15.416 7.708 7.708 0 000 15.416z"
        stroke="#D23580"
        strokeWidth={2.08333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle cx={37.0503} cy={31.1954} r={8.22222} fill="#F3F3F3" />
    </Svg>
  );
}

export default LocationPermissionErrorIconAramark;
